import React, { useEffect, useState } from "react";

import {
    Box,
    Grid,
    Paper,
    Button,
    TextField,
    Typography,
    IconButton,
    Tooltip,
} from "@material-ui/core";

import {
    Close,
    CropSquare,
    Remove,
    Apps,
    Add,
    Description,
    NoteAdd,
    Delete,
    Print,
    Cancel,
    TouchApp,
    InsertDriveFile,
    Inventory,
    BarChart,
} from "@material-ui/icons";

import "./SelectNotes.css";
import { sto } from "../../../Context/InshData";
import { uri } from "../../../help/Api";
import axios from "axios";
import { AddBillNaotesDialog } from "./addNotesCon";

// =============================
// Header
// =============================

const NotesHeader = () => {
    return (
        <div className="notes-header">

            <div className="notes-window-actions">

                <IconButton className="window-icon">
                    <Close />
                </IconButton>

                <IconButton className="window-icon">
                    <CropSquare />
                </IconButton>

                <IconButton className="window-icon">
                    <Remove />
                </IconButton>

            </div>

            <div className="notes-header-title">

                <Typography>
                    شاشة الملاحظات
                </Typography>

                <Apps className="header-app-icon" />

            </div>

        </div>
    );
};

// =============================
// Notes Canvas
// =============================

const NotesCanvas = ({ notes, onSelectNotes, activeTab }) => {

    return (

        <Paper className="notes-canvas">

            {notes.length === 0 && (

                <div className="notes-watermark">

                    <Description />

                </div>

            )}

            <div className="notes-list">

                {notes.map((note, index) => (

                    <Paper
                        key={index}
                        // className="note-card"
                        className={`notes-tab ${activeTab === note.id ? "active" : ""}`}
                        onClick={() => onSelectNotes(note)}
                    >

                        <Description />

                        <Typography>
                            {note.name}
                        </Typography>
                    </Paper>
                ))}
            </div>
        </Paper>
    );
};

// =============================
// Item Information
// =============================

const NotesItemInfo = ({
    itemNumber,
    itemName,
    quantity,
}) => {

    return (

        <Paper className="notes-item-info">

            <div className="info-group">

                <Typography className="info-label">
                    رقم الصنف
                </Typography>

                <TextField
                    value={itemNumber}
                    variant="outlined"
                    size="small"
                    InputProps={{
                        readOnly: true,
                    }}
                    className="info-input item-number"
                />

            </div>

            <div className="info-group item-name-group">

                <Typography className="info-label">
                    اسم الصنف
                </Typography>

                <TextField
                    value={itemName}
                    variant="outlined"
                    size="small"
                    InputProps={{
                        readOnly: true,
                    }}
                    className="info-input item-name"
                />

            </div>

            <div className="info-group">

                <Typography className="info-label">
                    الكمية
                </Typography>

                <TextField
                    value={quantity}
                    variant="outlined"
                    size="small"
                    InputProps={{
                        readOnly: true,
                    }}
                    className="info-input item-quantity"
                />

            </div>

        </Paper>

    );
};

// =============================
// Footer
// =============================

const NotesFooter = ({
    value,
    setValue,
    onAdd,
    onCancel,
    onConfirm,
    onClear,
    onSelectNotes
}) => {

    return (

        <div className="notes-footer">

            {/* Cancel */}

            <Button
                className="action-button cancel-button"
                onClick={onCancel}
            >

                <Cancel className="action-icon" />

                <span>
                    إلغاء
                </span>

            </Button>

            {/* Confirm */}

            <Button
                className="action-button confirm-button"
                onClick={onConfirm}
            >

                <TouchApp className="action-icon" />

                <span>
                    موافق
                </span>

            </Button>

            {/* Note Input */}

            <div className="notes-input-wrapper">

                <TextField
                    multiline
                    // rows={2}
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    variant="outlined"
                    //   placeholder="اكتب الملاحظة هنا..."
                    className="notes-input"
                    InputProps={{
                        endAdornment: (
                            <InsertDriveFile className="notes-input-icon" />
                        ),
                    }}
                />

            </div>

            {/* Right Buttons */}

            <div className="notes-side-buttons">

                <Button
                    className="side-action-button clear-button"
                    onClick={onClear}
                >
                    <Delete />
                    <span>
                        مسح الملاحظة
                    </span>
                </Button>

                <Button
                    className="side-action-button add-button"
                    onClick={onAdd}
                >

                    <NoteAdd />

                    <span>
                        إضافة ملاحظة
                    </span>

                </Button>

            </div>

        </div>

    );
};

// =============================
// Main Screen
// =============================

export default function NotesScreen(props) {
    const {isDialog,
        infoNotes,
        setInfoNotes,
        AddNotesToItem}=props;

    const [tabs, setTabs] = useState([
        "mussss",
    ]);

    const [activeTab, setActiveTab] = useState(6);

    const [notes, setNotes] = useState([]);

    const [noteValue, setNoteValue] = useState("");

    const itemNumber = infoNotes?.itemName?.currency_from;

    const itemName =  infoNotes?.itemName?.symbol;;
    const [isSearch, setIsSearch] = useState(false);
    const [openNotes, setOpenNotes] = useState(false);
    const quantity = 1;

    const viewHandle = async () => {
        setIsSearch(true)
        await axios
            .get(
                uri + `bill_notes?curr_id=${-1}&&group_id=${-1}&&curr_id=${sto?.db_name}`
            )
            .then((res) => {
                setNotes(res.data);
            })
            .catch((err) => {
                setNotes([]);
            });
    };
    useEffect(() => {
        if (!isSearch) {
            viewHandle();
        }
    }, [notes, isSearch]);
    // Add new tab

    const onSelectNotes = (notes) => {
        setNoteValue(prev =>
            prev ? `${prev}\n${notes?.name}` : notes?.name
        );
        setActiveTab(notes?.id);

    };

    // Add note

    const handleAddNote = () => {
        setOpenNotes(true);
    };

    // Clear note

    const handleClearNote = () => {
        setNoteValue("");
    };

    // Cancel

    const handleCancel = () => {
        setInfoNotes({open:false,item:{}});
    };

    // Confirm

    const handleConfirm = () => {
        // console.log("Notes:", notes);
        AddNotesToItem(noteValue);
    };

    return (

        <div className="notes-screen" dir="rtl">

            {/* Header */}
            <NotesHeader />
            <div className="notes-main">

                <NotesCanvas
                    notes={notes}
                    onSelectNotes={onSelectNotes}
                    activeTab={activeTab}
                />

                <NotesItemInfo
                    itemNumber={itemNumber}
                    itemName={itemName}
                    quantity={quantity}

                />

            </div>

            {/* Footer */}

            <NotesFooter
                value={noteValue}
                setValue={setNoteValue}
                onAdd={handleAddNote}
                onCancel={handleCancel}
                onConfirm={handleConfirm}
                onClear={handleClearNote}
            />
            {openNotes &&
                <AddBillNaotesDialog
                    openNotes={openNotes}
                    setOpenNotes={setOpenNotes} />
                    }
        </div>

    );

}